import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { RowDataDb, SubSectionRowData } from 'src/app/model/help';
import { HelperAddRowDialogComponent } from '../helper-add-row-dialog/helper-add-row.dialog.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subscription } from 'rxjs';
import { selectRowCurrent } from 'src/app/store/help/help.selector';
import * as HelpActions from 'src/app/store/help/help.actions';
import { ConfirmationService } from 'primeng/api';

@Component({
   selector: 'app-helper-row',
   templateUrl: './helper-row.component.html',
   changeDetection: ChangeDetectionStrategy.Default,
   providers: [ConfirmationService, DialogService]
})
export class HelperRowComponent implements OnInit {
   @Input() row: SubSectionRowData;
   @Input() controller: boolean;
   @Input() mobile: boolean;

   rowCurrent$: Observable<RowDataDb | undefined>;
   rowCurrentSub: Subscription | undefined;

   ref: DynamicDialogRef | undefined;

   acceptButtonStyle: string;
   rejectButtonStyle: string;

   // design
   screenWidth: number;
   MIN_MD_WIDTH = 500;

   constructor(
      private store: Store<AppState>,
      public dialogService: DialogService,
      private translate: TranslateService,
      public confirmationService: ConfirmationService,
   ) { }

   ngOnInit(): void {
      const tag = document.createElement('script');

      tag.src = 'https://www.youtube.com/iframe_api';
      document.body.appendChild(tag);
   }

   modificaRiga(): void {
      this.store.dispatch(HelpActions.resetGetHelpRow());
      this.store.dispatch(HelpActions.getHelpRow({
         rowId: this.row.Id
      }));
      this.rowCurrent$ = this.store.select(selectRowCurrent);
      this.rowCurrentSub = this.rowCurrent$.subscribe((rowCurrent) => {
         if (rowCurrent) {
            this.rowCurrentSub?.unsubscribe();
            this.ref = this.dialogService.open(HelperAddRowDialogComponent, {
               header: this.translate.instant('EDIT_ROW'),
               width: '50vw',
               breakpoints: { '1120px': '95vw' },
               // resizable: true,
               contentStyle: {
                  overflow: 'auto'
               },
               data: {
                  row: rowCurrent,
               },
            });
         }
      });
   }

   eliminaRiga(): void {
      this.acceptButtonStyle = "p-button-danger";
      this.rejectButtonStyle = "p-button-secondary";
      this.confirmationService.confirm({
         header: this.translate.instant('DELETE_HELP_ROW'),
         message: this.translate.instant('DELETE_HELP_ROW_WARNING'),
         acceptLabel: this.translate.instant('CONFIRM'),
         rejectLabel: this.translate.instant('CANCEL'),
         icon: 'pi cm-alert',
         accept: () => {
            this.store.dispatch(HelpActions.deleteHelpRow({
               rowId: this.row.Id
            }));
         },
         reject: () => {
         }
      });
   }

   getImageContent(content: string): string {
      return 'https://came-cdn.thron.com/delivery/public/image/came/' + content;
   }
}
